@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.sddamico.components.layouts.PageLayout as _com_sddamico_components_layouts_PageLayout
import com.sddamico.pages.ClubhousePage as _com_sddamico_pages_ClubhousePage
import com.sddamico.pages.HomePage as _com_sddamico_pages_HomePage
import com.sddamico.pages.ManageClubsPage as _com_sddamico_pages_ManageClubsPage
import com.sddamico.pages.ManageSchedulePage as _com_sddamico_pages_ManageSchedulePage
import com.sddamico.pages.PlayersPage as _com_sddamico_pages_PlayersPage
import com.sddamico.pages.ResultsPage as _com_sddamico_pages_ResultsPage
import com.sddamico.pages.RosterMovesPage as _com_sddamico_pages_RosterMovesPage
import com.sddamico.pages.SchedulePage as _com_sddamico_pages_SchedulePage
import com.sddamico.pages.SettingsPage as _com_sddamico_pages_SettingsPage
import com.sddamico.pages.SignInPage as _com_sddamico_pages_SignInPage
import com.sddamico.pages.StandingsPage as _com_sddamico_pages_StandingsPage
import com.sddamico.pages.TradePage as _com_sddamico_pages_TradePage
import com.sddamico.pages.TransactionsPage as _com_sddamico_pages_TransactionsPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Fantasy Country Club"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.sddamico.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_sddamico_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_HomePage()
        }
        ctx.router.register(
            "/clubhouse",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initClubhouse(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_ClubhousePage()
        }
        ctx.router.register(
            "/manage-clubs",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initManageClubs(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_ManageClubsPage()
        }
        ctx.router.register(
            "/manage-rosters",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initRosterMoves(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_RosterMovesPage()
        }
        ctx.router.register(
            "/manage-schedule",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initManageSchedule(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_ManageSchedulePage()
        }
        ctx.router.register(
            "/players",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initPlayers(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_PlayersPage()
        }
        ctx.router.register(
            "/results",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initResults(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_ResultsPage()
        }
        ctx.router.register(
            "/schedule",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initSchedule(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_SchedulePage()
        }
        ctx.router.register(
            "/settings",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initSettings(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_SettingsPage()
        }
        ctx.router.register(
            "/sign-in",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initSignIn(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_SignInPage()
        }
        ctx.router.register(
            "/standings",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initStandings(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_StandingsPage()
        }
        ctx.router.register(
            "/trade",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initTrade(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_TradePage()
        }
        ctx.router.register(
            "/transactions",
            layoutId = "com.sddamico.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.sddamico.pages.initTransactions(ctx)
            },
        ) { pageCtx -> 
            _com_sddamico_pages_TransactionsPage()
        }

        com.sddamico.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.sddamico.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.sddamico.SubheadlineTextStyle)
        ctx.theme.registerStyle("card", com.sddamico.CardStyle)
        ctx.theme.registerStyle("primary-button", com.sddamico.PrimaryButtonStyle)
        ctx.theme.registerStyle("ghost-button", com.sddamico.GhostButtonStyle)
        ctx.theme.registerStyle("badge", com.sddamico.BadgeStyle)
        ctx.theme.registerStyle("tab-bar", com.sddamico.TabBarStyle)
        ctx.theme.registerStyle("tab-item", com.sddamico.TabItemStyle)
        ctx.theme.registerStyle("mono-number", com.sddamico.MonoNumberStyle)
        ctx.theme.registerStyle("page-content", com.sddamico.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("wide-page-content", com.sddamico.components.layouts.WidePageContentStyle)
        ctx.theme.registerStyle("page-layer", com.sddamico.components.motion.PageLayerStyle)
        ctx.theme.registerStyle("pressable", com.sddamico.components.motion.PressableStyle)
        ctx.theme.registerStyle("stable-bold-label", com.sddamico.components.motion.StableBoldLabelStyle)
        ctx.theme.registerStyle("footer", com.sddamico.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", com.sddamico.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("skeleton", com.sddamico.components.widgets.SkeletonStyle)
        ctx.theme.registerStyle("clubhouse-grid", com.sddamico.pages.ClubhouseGridStyle)
        ctx.theme.registerStyle("breakdown-cards", com.sddamico.pages.BreakdownCardsStyle)
        ctx.theme.registerStyle("dashboard-grid", com.sddamico.pages.DashboardGridStyle)
        ctx.theme.registerStyle("trade-roster-grid", com.sddamico.pages.TradeRosterGridStyle)
        ctx.theme.registerStyle("trade-player-grid", com.sddamico.pages.TradePlayerGridStyle)
        ctx.theme.registerVariant("-circle", com.sddamico.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", com.sddamico.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("page-item-enter", com.sddamico.components.motion.PageItemEnterKeyframes)
        ctx.theme.registerKeyframes("fade-in", com.sddamico.components.motion.FadeInKeyframes)
        ctx.theme.registerKeyframes("shimmer", com.sddamico.components.widgets.ShimmerKeyframes)
        ctx.theme.registerKeyframes("modal-card-in", com.sddamico.components.widgets.ModalCardInKeyframes)
        ctx.theme.registerKeyframes("modal-card-out", com.sddamico.components.widgets.ModalCardOutKeyframes)
        ctx.theme.registerKeyframes("fade-out", com.sddamico.components.widgets.FadeOutKeyframes)
        ctx.theme.registerKeyframes("sign-in-step-forward", com.sddamico.pages.SignInStepForwardKeyframes)
        ctx.theme.registerKeyframes("sign-in-step-back", com.sddamico.pages.SignInStepBackKeyframes)
        com.sddamico.initColorMode(ctx)
        com.sddamico.initSiteStyles(ctx)
        com.sddamico.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.sddamico.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
